import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
	paper: {
		border: 0,
		boxShadow: theme.shadows[0]
	},
	formLabel: {
		marginTop: 8
	},
	formGroup: {
		marginTop: 10
	}
}));
